/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ReferentialGetPagination$Json$Params {
  applicationType?: string;
}

export function referentialGetPagination$Json(http: HttpClient, rootUrl: string, params?: ReferentialGetPagination$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<any>>> {
  const rb = new RequestBuilder(rootUrl, referentialGetPagination$Json.PATH, 'get');
  if (params) {
    rb.query('applicationType', params.applicationType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<any>>;
    })
  );
}

referentialGetPagination$Json.PATH = '/v1/Referential/GetPagination';
